import { Button, Card, Col, DatePicker, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import useHttp from "../../../hooks/use-http";
import dayjs from "dayjs";
import ReactToPrint from "react-to-print";
const Dashboard = () => {
  const [analytics, setAnalytics] = useState({})
  const [selectedDates, setSelectedDates] = useState({
    startDate: null,
    endDate: null,
  })
  const componentRef = useRef();
  const API = useHttp();
  const { RangePicker } = DatePicker;

  // console.log(analytics);

  useEffect(() => {
    const ANALYTICS_API = { ...CONSTANTS.API.Analytics.getAll }

    if ((selectedDates?.startDate !== null && selectedDates?.endDate !== null)) {
      ANALYTICS_API.endpoint = `${ANALYTICS_API.endpoint}?startDate=${selectedDates?.startDate}&endDate=${selectedDates?.endDate}`
    }

    API.sendRequest(ANALYTICS_API, (res) => {
      setAnalytics(res?.data)
    })
  }, [selectedDates])

  return (
    <>
      <div className="">
        <div className="my-5">
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Card>
                <p className="font-medium text-lg pb-5">Date Range</p>
                <RangePicker
                  className="w-3/4"
                  onChange={(e) => {
                    // console.log(e);
                    if (e) {
                      setSelectedDates({
                        startDate: dayjs(e[0])?.format("YYYY-MM-DD"),
                        endDate: dayjs(e[1])?.format("YYYY-MM-DD"),
                      });
                    }
                    else {
                      setSelectedDates({
                        startDate: null,
                        endDate: null,
                      });
                    }
                  }}
                />
                <ReactToPrint
                  trigger={() => <Button
                    onClick={() => {

                    }}
                    className="float-right"
                    type="primary"
                  >
                    Download Analytics
                  </Button>}
                  content={() => componentRef.current}
                />
              </Card>
            </Col>
          </Row>
        </div>

        <Row gutter={[16, 16]} className="mt-2 mb-5" ref={componentRef}>
          <Col span={8} xs={24} sm={12} md={8} lg={8} xl={8} >
            <Card className="p-7">
              <div>
                <p className="font-semibold text-base text-slate-400">Total User</p>
                <p className="pt-2 font-medium text-xl ">{analytics?.user}</p>
              </div>
            </Card>
          </Col>
          <Col span={8} xs={24} sm={12} md={8} lg={8} xl={8} >
            <Card className="p-7">
              <div>
                <p className="font-semibold text-base text-slate-400">Total Device</p>
                <p className="pt-2 font-medium text-xl ">{analytics?.totalDevice}</p>
              </div>
            </Card>
          </Col>
          <Col span={8} xs={24} sm={12} md={8} lg={8} xl={8} >
            <Card className="p-7">
              <div>
                <p className="font-semibold text-base text-slate-400">Total Active Device</p>
                <p className="pt-2 font-medium text-xl ">{analytics?.activeDevice}</p>
              </div>
            </Card>
          </Col>
          <Col span={8} xs={24} sm={12} md={8} lg={8} xl={8}  >
            <Card className="p-7">
              <div>
                <p className="font-semibold text-base text-slate-400">Total Pets</p>
                <p className="pt-2 font-medium text-xl ">{analytics?.totalPets}</p>
              </div>
            </Card>
          </Col>
          <Col span={8} xs={24} sm={12} md={8} lg={8} xl={8}  >
            <Card className="p-7">
              <div>
                <p className="font-semibold text-base text-slate-400">Total Feedback</p>
                <p className="pt-2 font-medium text-xl ">{analytics?.totalFeedback}</p>
              </div>
            </Card>
          </Col>
          {analytics?.userSubscriptionData?.map(item1 => {
            return analytics?.ActiveUserSubscriptionData?.map(item2 => {
              if (item1.subPlanId === item2.subPlanId) {

                return <Col key={item1?.subPlanId} span={8} xs={24} sm={12} md={8} lg={8} xl={8}  >
                  <Card className="p-2">
                    <div>
                      {/* <p className="font-semibold text-base text-slate-400">Plan Name</p> */}
                      <p className="pt-1 font-medium text-xl ">{item1?.subPlan?.name}</p>
                      <div className="pt-1 flex gap-6">
                        <div> <p className="font-semibold text-base text-slate-400">Total User</p>
                          <p className="pt-2 font-medium text-xl ">{item1?.userCount}</p></div>
                        <div> <p className="font-semibold text-base text-[#4DCD1F]">Activate User</p>
                          <p className="pt-2 font-medium text-xl ">{item2?.userCount}</p></div>
                      </div>
                    </div>
                  </Card>
                </Col>
              }
            })
          })}
          {/* {analytics?.userSubscriptionData?.map(ele => <Col key={ele?.subPlanId} span={8} xs={24} sm={12} md={8} lg={8} xl={8}  >
            <Card className="p-5">
              <div>
                <p className="font-semibold text-base text-slate-400">Total User of {ele?.subPlan?.name}</p>
                <p className="pt-2 font-medium text-xl ">{ele?.userCount}</p>
              </div>
            </Card>
          </Col>)}
          {analytics?.ActiveUserSubscriptionData?.map(ele => <Col key={ele?.subPlanId} span={8} xs={24} sm={12} md={8} lg={8} xl={8}  >
            <Card className="p-5">
              <div>
                <p className="font-semibold text-base text-slate-400">Activate User of {ele?.subPlan?.name}</p>
                <p className="pt-2 font-medium text-xl ">{ele?.userCount}</p>
              </div>
            </Card>
          </Col>)} */}

        </Row>
      </div>
    </>

  );
};

export default Dashboard;
